import { render, staticRenderFns } from "./EspacoViverBemComponente.vue?vue&type=template&id=9fdb078a&scoped=true"
import script from "./EspacoViverBemComponente.vue?vue&type=script&lang=js"
export * from "./EspacoViverBemComponente.vue?vue&type=script&lang=js"
import style0 from "./EspacoViverBemComponente.vue?vue&type=style&index=0&id=9fdb078a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fdb078a",
  null
  
)

export default component.exports